__turbopack_context__.v({
  "category": "_2gpdcq_category",
  "container": "_2gpdcq_container",
  "containerCard": "_2gpdcq_containerCard",
  "firstImg": "_2gpdcq_firstImg",
  "h3Platform": "_2gpdcq_h3Platform",
  "image": "_2gpdcq_image",
  "imageContainer": "_2gpdcq_imageContainer",
  "pPlatform": "_2gpdcq_pPlatform",
  "paragraph": "_2gpdcq_paragraph",
  "rowEtc": "_2gpdcq_rowEtc",
  "text": "_2gpdcq_text",
  "title": "_2gpdcq_title",
});
